export const getLanguage = (state) => state.language.language;
export const getLanguages = (state) => state.language.languageList;
